import { downloadCSV, type Exporter } from "react-admin";
import jsonExport from "jsonexport/dist";

const statusChoices = [
  { id: "IN_PROGRESS", name: "En cours" },
  { id: "COMPLETED", name: "Terminé" },
  { id: "CANCELLED", name: "Annulé" },
];

const statusLabels = statusChoices.reduce(
  (acc, { id, name }) => ({ ...acc, [id]: name }),
  {} as Record<string, string>
);

const priorityChoises = [
  { id: 0, name: "Basse" },
  { id: 1, name: "Médium" },
  { id: 2, name: "Elevé" },
];

const formatDate = (value?: any) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("fr-FR");
};

const formatDateTime = (value?: any) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("fr-FR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const orderExporter: Exporter = async (records, fetchRelatedRecords) => {
  const clients = await fetchRelatedRecords(records, "client", "clients");
  const providers = await fetchRelatedRecords(records, "provider", "providers");

  const data = records.map((order: any) => {
    const client = clients[order.client];
    const provider = providers[order.provider];

    return {
      "Numéro BDC": order.orderNumber ?? "",
      Statut: statusLabels[order.status] ?? order.status ?? "",
      Priorité: priorityChoises[order.priority] ?? order.priority ?? "",

      "Date création": formatDateTime(order.createdAt),
      "Date prévisionnelle": formatDate(order.provisionalDate),
      "Date d'exécution": formatDateTime(order.executionDate),

      "Code client": client?.internalCode ?? "",
      "Nom client": client?.name ?? "",

      "Code prestataire": provider?.internalCode ?? "",
      "Nom prestataire": provider?.name ?? "",

      "Qté caisse à récupérer": order.quantityBin ?? 0,
      "Qté airbag en vrac": order.quantityAirbag ?? 0,

      "Qté caisses récupérées (réel)": order.fullBinsCollectedCount ?? "",
      "Qté caisses déposées (réel)": order.emptyBinsDepositCount ?? "",

      "Airbags collectés": order.airbagsCollectedCount ?? "",
      "Airbags restants": order.airbagsRemainingCount ?? "",

      Commentaire: order.comment ?? "",
      "Lien externe collecte": order.externalCollectLink ?? "",

      "Envoyer email au client": order.sendEmailToClient ? "Oui" : "Non",
      "Créer BDC dans MKGT": order.createBdcInMkgt ? "Oui" : "Non",
    };
  });

  jsonExport(
    data,
    {
      // optionnel : forcer l'ordre des colonnes
      headers: [
        "Numéro BDC",
        "Statut",
        "Priorité",
        "Date création",
        "Date prévisionnelle",
        "Date d'exécution",
        "Code client",
        "Nom client",
        "Code prestataire",
        "Nom prestataire",
        "Qté caisse à récupérer",
        "Qté airbag en vrac",
        "Qté caisses récupérées (réel)",
        "Qté caisses déposées (réel)",
        "Airbags collectés",
        "Airbags restants",
        "Commentaire",
        "Lien externe collecte",
        "Envoyer email au client",
        "Créer BDC dans MKGT",
      ],
    },
    (err: any, csv: string) => {
      if (err) return;
      downloadCSV(csv, "bons_de_commande");
    }
  );
};
